export const ONBOARDING = 'onboarding';
export const VARO_ADVANCE = 'varo-advance';
export const PROGRESS_TRACKER_FUNDING = 'progress-tracker-funding';
export const DD_EXPERIMENT_ENABLED_PAGES = ['funding', 'move-money'];
